<app-popup [wide]="wide()">
  <div i18n trigger class="info-icon">i</div>
  <div content>
    <ng-content />
  </div>
</app-popup>
